import { API_BASE_URL, LOCAL_STORAGE_KEYS, APP_NAME } from '../constants';
import { redirect } from "react-router-dom";

const request = async (options) => {
    const headers = options.headers || {};

    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    }

    if (APP_NAME) {
        headers['App-Name'] = APP_NAME;
    }

    const fetchOptions = {
        method: options.method,
        headers: headers,
    };

    if (options.body) {
        fetchOptions.body = options.body;
    }

    return fetch(options.url, fetchOptions)
        .then(response => {
            // Refresh token auto : si le backend a renouvelé le token expiré,
            // il renvoie le nouveau Bearer dans le header Authorization de la réponse.
            const newAuth = response.headers.get('Authorization') || response.headers.get('authorization');
            if (newAuth && newAuth.startsWith('Bearer ')) {
                const newToken = newAuth.substring(7);
                const current = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
                if (newToken && newToken !== current) {
                    localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, newToken);
                }
            }
            return response.json().then(json => {
                if (!response.ok) {
                    json = Object.assign({}, { status: response.status }, json);
                    return Promise.reject(json);
                }
                return json;
            });
        });
};

export const SESSION_EXPIRED_KEY = 'session_expired_redirect';
export const SESSION_RETURN_URL = 'session_return_url';

export function handleLogout() {
  // Sauvegarde l'URL courante pour redirect après login
  try {
    const path = window.location.pathname + window.location.search;
    if (path && path !== '/' && !path.includes('/login')) {
      sessionStorage.setItem(SESSION_RETURN_URL, path);
    }
    sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
  } catch { /* sessionStorage indisponible */ }

  localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
  // Hard redirect — coupe court à tout state React stale
  window.location.replace('/');
}

export async function exeRequest(relativeUrl, method, data) {
  const isFormData = data instanceof FormData;

  let options = {
    url: API_BASE_URL + relativeUrl,
    method: method,
    headers: {},
  };

  if (!isFormData) {
    options.headers['Content-Type'] = 'application/json';
    if (data && Object.keys(data).length > 0) {
      options.body = JSON.stringify(data);
    }
  } else {
    options.body = data;
  }

  try {
    return await request(options);
  } catch (error) {
    if (error.status === 401) {
      handleLogout();
    } else {
      // Log neutralisé : ne pas écrire le body de la réponse (peut contenir des données métier)
      console.error('[API]', options.method, relativeUrl, '→', error?.status || '?', error?.message || 'unknown error');
      throw error;
    }
  }
}
